export const selectFormBundleSchema = ({ formBundleSchema }) => formBundleSchema;
